var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-blog-image",style:({ backgroundImage: _vm.backgroundImage, paddingTop: _vm.paddingTop })})}
var staticRenderFns = []

export { render, staticRenderFns }